// extracted by mini-css-extract-plugin
export default {"delete_part":"delete_delete_part__qRV7A","delete_button":"delete_delete_button__l4fH3","loading":"delete_loading__uTg7d"};